export function getSupportEmail(): string {
  return import.meta.env.VITE_SUPPORT_EMAIL ?? "support@swiftmvp.com";
}
